document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  if (variantId) {
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event('change')); // Trigger update
    }
  }
});